import React from 'react';
import { CONTACT } from '../../data/contactDetails';
import { IconMail, IconPhone, IconLocation, IconClock } from '../icons/ContactIcons';
import './ContactDetails.css';

function ContactDetail({ icon, label, children }) {
  return (
    <div className="contact-detail">
      <div className="contact-icon">{icon}</div>
      <div>
        <div className="contact-detail-label">{label}</div>
        <div className="contact-detail-text">{children}</div>
      </div>
    </div>
  );
}

function ContactDetails() {
  return (
    <div className="contact-details">
      {CONTACT.offices.map((office) => (
        <ContactDetail key={office.label} icon={<IconLocation />} label={office.label}>
          {office.lines.map((line, i) => (
            <span key={line}>
              {line}
              {i < office.lines.length - 1 && <br />}
            </span>
          ))}
        </ContactDetail>
      ))}

      <ContactDetail icon={<IconMail />} label="Email">
        <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
      </ContactDetail>

      <ContactDetail icon={<IconPhone />} label="Phone">
        <div className="contact-phones">
          {CONTACT.phones.map((p) => (
            <div key={p.label} className="contact-phone-row">
              <strong>{p.label}:</strong>{' '}
              <a href={`tel:${p.tel}`}>{p.display}</a>
            </div>
          ))}
        </div>
      </ContactDetail>

      <ContactDetail icon={<IconClock />} label="Working Hours">
        {CONTACT.workingHours}
        <span className="contact-note">{CONTACT.responseNote}</span>
      </ContactDetail>

      <div className="contact-sidecards">
        <div className="contact-social-connect">
          <h3 className="contact-social-title">Connect With Us</h3>
          <div className="contact-social-links">
            {CONTACT.social.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-link"
                aria-label={s.label}
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        <div className="contact-whatsapp">
          <p className="contact-whatsapp-title">Chat on WhatsApp</p>
          <p className="contact-whatsapp-sub">Quick response for urgent inquiries</p>
          <div className="contact-whatsapp-links">
            {CONTACT.phones.map((p) => (
              <a
                key={p.label}
                href={p.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-line btn-sm"
              >
                {p.label}: {p.display}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
